// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-email-modal-body {
  padding: 1.5rem 1.25rem 1.25rem;
  background: var(--ion-background-color, #fff);
}

.store-email-modal-text {
  margin: 0 0 1rem;
  font-size: 0.95rem;
  color: var(--ion-text-color);
}

ion-item {
  --padding-start: 0;
  --inner-padding-end: 0;
}

.store-email-modal-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
}
.store-email-modal-actions ion-button {
  flex: 1;
  margin: 0;
  --border-radius: 12px;
  text-transform: none;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/components/store-email-modal/store-email-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,6CAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,4BAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AACF;AACE;EACE,OAAA;EACA,SAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AACJ","sourcesContent":[".store-email-modal-body {\n  padding: 1.5rem 1.25rem 1.25rem;\n  background: var(--ion-background-color, #fff);\n}\n\n.store-email-modal-text {\n  margin: 0 0 1rem;\n  font-size: 0.95rem;\n  color: var(--ion-text-color);\n}\n\nion-item {\n  --padding-start: 0;\n  --inner-padding-end: 0;\n}\n\n.store-email-modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1.5rem;\n\n  ion-button {\n    flex: 1;\n    margin: 0;\n    --border-radius: 12px;\n    text-transform: none;\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
